import { render, staticRenderFns } from "./lectureDetails_video.vue?vue&type=template&id=07736b14&scoped=true&"
import script from "./lectureDetails_video.vue?vue&type=script&lang=js&"
export * from "./lectureDetails_video.vue?vue&type=script&lang=js&"
import style0 from "./lectureDetails_video.vue?vue&type=style&index=0&id=07736b14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07736b14",
  null
  
)

export default component.exports